import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=926013e4&"
import script from "./PageContainer.vue?vue&type=script&lang=ts&"
export * from "./PageContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports